import { computed, makeAutoObservable } from "mobx"

const TAX = 1.21;
export class Product{
    data
    store
    constructor({store, ...rest}){
        makeAutoObservable(this)
        this.store = store
        this.data = rest
    }    
    @computed get basePrice() {
        const defaultConfiguration = this.store.config.defaultConfiguration;
        const found = defaultConfiguration.find(p => p.category_id === this.category_id);
        if(found){
            const product = this.store.materials.find(p=>p.id === found.id && p.category_id === found.category_id);
            if(product){
                return (parseFloat(product.data.price) || 0 ) * TAX;
            }
        }
        return 0;
    }
    @computed get fullPrice() {

        return (parseFloat(this.data.price) || 0) * TAX;
    }
    @computed get price() {

        return (parseFloat(this.data.price) || 0) * TAX - this.basePrice;
    }
    @computed get deliveryTime() {
        const time = parseInt(this.data.delivery_in_stock.en) || parseInt(this.data.delivery_in_stock.en) || 1;
        return time;
    }

    @computed get id(){
        return this.data?.id;
    }
    @computed get name(){
        return this.data?.name;
    }
    @computed get battery_icon_text(){
        return this.data?.battery_icon_text;
    }
    @computed get color_name(){
        return this.data?.color_name;
    }
    @computed get subcategory(){
        return this.data?.subcategory;
    }
    @computed get category(){
        return this.data?.category;
    }
    @computed get thumbnail(){
        return this.data?.thumbnail;
    }
    @computed get thumbnail2(){
        return this.data?.thumbnail2;
    }
    @computed get color(){
        return this.data?.color;
    }
    @computed get color2(){
        return this.data?.color2;
    }
    @computed get material_name(){
        return this.data?.material_name;
    }
    @computed get category_id(){
        return this.data?.category_id;
    }
    @computed get subcategory_id(){
        return this.data?.subcategory_id;
    }
    @computed get showNodes(){
        return this.data?.showNodes;
    }
    @computed get hideNodes(){
        return this.data?.hideNodes;
    }
    @computed get channels(): Array<{colorFieldName:String, material_name:String, thumbnail:String}>{
        return this.data?.channels || [];
    }
}